"use strict";

exports.__esModule = true;
exports.yAxis = void 0;
var _react = _interopRequireDefault(require("react"));
var _recharts = require("recharts");
var _utils = require("./utils");
var _excluded = ["hide", "domain", "theme"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var yAxis = exports.yAxis = function yAxis(_ref) {
  var _ref$hide = _ref.hide,
    hide = _ref$hide === void 0 ? false : _ref$hide,
    _ref$domain = _ref.domain,
    domain = _ref$domain === void 0 ? ["dataMin", "dataMax"] : _ref$domain,
    theme = _ref.theme,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_recharts.YAxis, _extends({
    domain: domain,
    tick: theme.uiModern ? {
      fontSize: 10.5,
      fill: theme.ChartAxisTextColor,
      fontFamily: theme.ChartFontFamilyMono
    } : {
      fontSize: theme.fontSizeXS,
      fill: theme.color
    },
    axisLine: !theme.uiModern,
    tickLine: !theme.uiModern,
    hide: hide,
    tickFormatter: _utils.yTickFormatter
  }, extra));
};